import {panelArrowLeftSvg as Icon__small__panelArrowLeftSvg} from '../Icon__small/Icon__small--panelArrowLeft.js'
import {panelArrowLeftSvg as Icon__xsmall__panelArrowLeftSvg} from '../Icon__xsmall/Icon__xsmall--panelArrowLeft.js'

export var panelArrowLeft = {
  name: 'panelArrowLeft',
  category: 'icon',
  colorable: true,
  svg: Icon__small__panelArrowLeftSvg,
  alt: {
    Icon__small: Icon__small__panelArrowLeftSvg,
    Icon__xsmall: Icon__xsmall__panelArrowLeftSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
